export interface SVGOpts {
  class?: string;
  width?: string;
  height?: string;
  name?: string;
}
